// Nahulis — scripts propios (vanilla, sin dependencias)

function initReveals() {
  const els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    els.forEach((el) => el.classList.add('mt-visible'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach((el) => io.observe(el));
}

function initContadores() {
  const els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const anima = (el) => {
    const fin = parseFloat(el.dataset.mtContador) || 0;
    const prefijo = el.dataset.mtPrefijo || '';
    const sufijo = el.dataset.mtSufijo || '';
    const decimales = el.dataset.mtDecimales ? parseInt(el.dataset.mtDecimales, 10) : 0;
    if (reduce) {
      el.textContent = prefijo + fin.toFixed(decimales) + sufijo;
      return;
    }
    const duracion = 1400;
    const inicio = performance.now();
    const paso = (ahora) => {
      const t = Math.min(1, (ahora - inicio) / duracion);
      const ease = 1 - Math.pow(1 - t, 3);
      el.textContent = prefijo + (fin * ease).toFixed(decimales) + sufijo;
      if (t < 1) requestAnimationFrame(paso);
    };
    requestAnimationFrame(paso);
  };
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          anima(entry.target);
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );
  els.forEach((el) => io.observe(el));
}

function initTiltCards() {
  const cards = document.querySelectorAll('[data-mt-tilt]');
  if (!cards.length) return;
  if (window.matchMedia('(hover: none)').matches) return;
  cards.forEach((card) => {
    card.addEventListener('mousemove', (e) => {
      const r = card.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      card.style.transform = `perspective(800px) rotateX(${(-y * 5).toFixed(2)}deg) rotateY(${(x * 5).toFixed(2)}deg) translateY(-4px)`;
    });
    card.addEventListener('mouseleave', () => {
      card.style.transform = '';
    });
  });
}

function initGaleria() {
  const galeria = document.querySelector('.mt-producto-galeria');
  if (!galeria) return;
  const slides = galeria.querySelectorAll('[data-mt-slide]');
  const thumbs = galeria.querySelectorAll('[data-mt-thumb]');
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const idx = thumb.dataset.mtThumb;
      slides.forEach((s) => s.classList.toggle('mt-activo', s.dataset.mtSlide === idx));
      thumbs.forEach((t) => t.classList.toggle('mt-activo', t.dataset.mtThumb === idx));
    });
  });
}

function moneyFormat(cents) {
  const amount = (cents / 100).toFixed(2);
  const format = window.mtMoneyFormat || '${{amount}}';
  return format.replace(/\{\{\s*amount\s*\}\}/, amount);
}

function initPopup() {
  const overlay = document.getElementById('mt-popup-overlay');
  if (!overlay) return;
  const KEY = 'mt_popup_oculto_hasta';
  const SESION = 'mt_popup_visto';
  const dias = parseInt(overlay.dataset.mtPopupDias, 10) || 14;
  const retraso = Math.max(30, parseInt(overlay.dataset.mtPopupRetraso, 10) || 30);
  const paso1 = document.getElementById('mt-popup-paso-1');
  const paso2 = document.getElementById('mt-popup-paso-2');

  function marcarVisto() { try { document.cookie = 'mt_popup_visto=1; path=/; SameSite=Lax'; } catch (err) {} }
  function yaVisto() { return /(?:^|;\s*)mt_popup_visto=1/.test(document.cookie); }

  function guardar() {
    try { localStorage.setItem(KEY, String(Date.now() + dias * 24 * 60 * 60 * 1000)); } catch (err) {}
    try { sessionStorage.setItem(SESION, '1'); } catch (err) {}
    marcarVisto();
  }

  function ocultar() {
    overlay.classList.remove('mt-popup-visible');
    setTimeout(() => { overlay.hidden = true; }, 350);
    guardar();
  }

  function mostrar() {
    overlay.hidden = false;
    setTimeout(() => overlay.classList.add('mt-popup-visible'), 30);
    try { sessionStorage.setItem(SESION, '1'); } catch (err) {}
    marcarVisto();
  }

  const posted = new URLSearchParams(window.location.search).get('customer_posted');
  if (posted === 'true') {
    paso1.hidden = true;
    paso2.hidden = false;
    mostrar();
    guardar();
  } else {
    const llegaConDescuento = /[?&]utm_source=(doorhanger|flyer|mail)/.test(window.location.search) || /(?:^|;\s*)discount_code=/.test(document.cookie);
    if (llegaConDescuento) return;
    let ocultoHasta = 0;
    try { ocultoHasta = parseInt(localStorage.getItem(KEY), 10) || 0; } catch (err) {}
    if (Date.now() < ocultoHasta) return;
    try { if (sessionStorage.getItem(SESION)) return; } catch (err) {}
    if (yaVisto()) return;

    let listo = false;
    const escribiendo = () => {
      const el = document.activeElement;
      if (document.body.classList.contains('mt-embudo-abierto') || document.body.classList.contains('mt-resena-abierta') || document.body.classList.contains('mt-quiz-abierto')) return true;
      return el && /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName) && !overlay.contains(el);
    };
    const intentar = () => {
      if (listo) return;
      if (escribiendo()) { setTimeout(intentar, 8000); return; }
      listo = true;
      mostrar();
    };
    const t0 = Date.now();
    setTimeout(intentar, retraso * 1000);
    document.addEventListener('mouseout', (e) => {
      if (!e.relatedTarget && e.clientY <= 0 && Date.now() - t0 > 10000) intentar();
    });
  }

  document.getElementById('mt-popup-cerrar').addEventListener('click', ocultar);
  document.getElementById('mt-popup-omitir').addEventListener('click', ocultar);
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) ocultar();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('mt-popup-visible')) ocultar();
  });
}

function initDoorBanner() {
  const banner = document.getElementById('mt-door-banner');
  if (!banner) return;
  try { if (/[?&]utm_source=doorhanger/.test(window.location.search)) sessionStorage.setItem('mt_door', '1'); } catch (err) {}
  let activo = /[?&]utm_source=doorhanger/.test(window.location.search);
  try { if (sessionStorage.getItem('mt_door')) activo = true; } catch (err) {}
  if (activo) banner.hidden = false;
}

function initAntesDespues() {
  document.querySelectorAll('[data-mt-ba]').forEach((box) => {
    const mango = box.querySelector('.mt-ba-mango');
    if (!mango) return;
    const soloMango = box.hasAttribute('data-mt-ba-mango'); // en carruseles: solo el mango arrastra (el resto de la imagen deja deslizar el carrusel)
    let pos = 50;
    let arrastrando = false;
    let intro = null;
    function poner(p) {
      pos = Math.max(0, Math.min(100, p));
      box.style.setProperty('--mt-ba', pos + '%');
      mango.setAttribute('aria-valuenow', String(Math.round(pos)));
      box.classList.toggle('mt-ba-sin-antes', pos < 16);
      box.classList.toggle('mt-ba-sin-despues', pos > 84);
    }
    function desdeEvento(e) {
      const r = box.getBoundingClientRect();
      if (r.width > 0) poner(((e.clientX - r.left) / r.width) * 100);
    }
    function pararIntro() { if (intro) { clearTimeout(intro); intro = null; } }
    box.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (soloMango && !e.target.closest('.mt-ba-mango')) return;
      pararIntro();
      arrastrando = true;
      try { box.setPointerCapture(e.pointerId); } catch (err) {}
      desdeEvento(e);
      box.classList.add('mt-ba-activo');
    });
    box.addEventListener('pointermove', (e) => { if (arrastrando) desdeEvento(e); });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((t) => box.addEventListener(t, () => {
      arrastrando = false;
      box.classList.remove('mt-ba-activo');
    }));
    mango.addEventListener('keydown', (e) => {
      const paso = e.shiftKey ? 10 : 4;
      let usado = true;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') poner(pos - paso);
      else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') poner(pos + paso);
      else if (e.key === 'Home') poner(0);
      else if (e.key === 'End') poner(100);
      else usado = false;
      if (usado) { e.preventDefault(); pararIntro(); }
    });
    poner(50);
    // pequeña demostración al cargar para invitar a arrastrar
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && !box.hasAttribute('data-mt-ba-sin-demo')) {
      const ruta = [];
      for (let i = 0; i <= 20; i++) ruta.push(50 + 24 * Math.sin((i / 20) * Math.PI * 2));
      let i = 0;
      const paso = () => {
        if (i >= ruta.length) { intro = null; return; }
        poner(ruta[i++]);
        intro = setTimeout(paso, 55);
      };
      intro = setTimeout(paso, 1200);
    }
  });
}

function initHeroExtras() {
  const info = document.querySelector('[data-mt-ba-info]');
  const tip = document.getElementById('mt-ba-tip');
  if (info && tip) {
    let cierre = null;
    const cerrar = () => { tip.hidden = true; info.setAttribute('aria-expanded', 'false'); clearTimeout(cierre); };
    info.addEventListener('click', (e) => {
      e.stopPropagation();
      if (tip.hidden) {
        tip.hidden = false;
        info.setAttribute('aria-expanded', 'true');
        clearTimeout(cierre);
        cierre = setTimeout(cerrar, 7000);
      } else cerrar();
    });
    document.addEventListener('click', (e) => { if (!tip.hidden && !tip.contains(e.target)) cerrar(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') cerrar(); });
  }
  document.querySelectorAll('[data-mt-ticker]').forEach((t) => {
    let soltar = null;
    t.addEventListener('touchstart', () => { clearTimeout(soltar); t.classList.add('mt-ticker-pausa'); }, { passive: true });
    ['touchend', 'touchcancel'].forEach((ev) => t.addEventListener(ev, () => { soltar = setTimeout(() => t.classList.remove('mt-ticker-pausa'), 800); }, { passive: true }));
  });
}

function initCarruselBeneficios() {
  document.querySelectorAll('[data-mt-carrusel]').forEach((grid) => {
    const seccion = grid.closest('section');
    const dots = seccion ? Array.from(seccion.querySelectorAll('.mt-beneficios-dot')) : [];
    const tarjetas = Array.from(grid.children);
    if (!dots.length || tarjetas.length < 2) return;
    let pendiente = false;
    function indiceActual() {
      const centro = grid.scrollLeft + grid.clientWidth / 2;
      let mejor = 0, dist = Infinity;
      tarjetas.forEach((t, i) => {
        const d = Math.abs(t.offsetLeft + t.offsetWidth / 2 - centro);
        if (d < dist) { dist = d; mejor = i; }
      });
      return mejor;
    }
    function marcar() {
      pendiente = false;
      const idx = indiceActual();
      dots.forEach((d, i) => d.classList.toggle('mt-activo', i === idx));
    }
    grid.addEventListener('scroll', () => { if (!pendiente) { pendiente = true; setTimeout(marcar, 60); } }, { passive: true });
    dots.forEach((d, i) => d.addEventListener('click', () => {
      const t = tarjetas[i];
      grid.scrollTo({ left: t.offsetLeft - (grid.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
    }));
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initReveals();
  initTiltCards();
  initGaleria();
  initDoorBanner();
  initAntesDespues();
  initCarruselBeneficios();
  initHeroExtras();
  initPopup();
});
